import api from '@/services/api';

const meeting = {
  state: () => ({
    status: false,
    baseInfo: {},
    userInfo: {},
  }),
  mutations: {
    stateUpdate(state, payload) {
      state.status = payload;
    },
    infoUpdate(state, payload) {
      state.baseInfo = payload;
    },
    userUpdate(state, payload) {
      state.userInfo = payload;
    },
  },
  actions: {
    getInfo({ commit }, id) {
      commit('stateUpdate', false);
      return api.getInfo(id).then(([status, res]) => {
        if (status) {
          commit('stateUpdate', true);
          commit('infoUpdate', res.data);
          return true;
        } else {
          return false;
        }
      });
    },
  },
};

export default meeting;
